import { MAX_COLLECTION_EVENTS_REQUESTS_SIZE } from 'meta/pages/v4/eventCollection'

import { joinParts } from '../utils'

export const eventCollection = {
  data: (collectionId: string) => joinParts('eventcollections', collectionId),
  bulk: (codes: string[]) => `/eventcollections?ids=${codes.join(',')}`,
  events: (collectionId: string, page: number) =>
    `eventcollections/${collectionId}/events?page=${page}&size=${MAX_COLLECTION_EVENTS_REQUESTS_SIZE}`,
  activeEvents: (collectionId: string, page: number) =>
    `eventcollections/${collectionId}/activeEvents?page=${page}&size=${MAX_COLLECTION_EVENTS_REQUESTS_SIZE}`,
  activeTypeticketcollections: (collectionId: string, page: number) =>
    `eventcollections/${collectionId}/activeTypeticketcollections?page=${page}&size=${MAX_COLLECTION_EVENTS_REQUESTS_SIZE}`,
}
